import {
  Flex,
  IconButton,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';

function EyeButton({
  visible,
  onToggle,
}: {
  visible: boolean;
  onToggle: () => void;
}) {
  const label = visible ? 'Esconder' : 'Mostrar';

  return (
    <Tooltip label={label} bg="gray.650" hasArrow>
      <IconButton
        aria-label={label}
        aria-pressed={visible}
        icon={visible ? <FiEyeOff /> : <FiEye />}
        size="xs"
        variant="ghost"
        onClick={onToggle}
      />
    </Tooltip>
  );
}

// Campo de senha com o "olhinho" para mostrar o que foi digitado.
export function SecretInput(props: InputProps) {
  const [visible, setVisible] = useState(false);

  return (
    <InputGroup>
      <Input {...props} type={visible ? 'text' : 'password'} pr="10" />
      <InputRightElement>
        <EyeButton visible={visible} onToggle={() => setVisible(!visible)} />
      </InputRightElement>
    </InputGroup>
  );
}

// Valor secreto exibido como •••• com o "olhinho" ao lado.
export function SecretText({ value }: { value: string }) {
  const [visible, setVisible] = useState(false);

  if (!value) {
    return <Text color="gray.500">—</Text>;
  }

  return (
    <Flex align="center" gridGap="1" minW="0">
      <Text
        wordBreak="break-all"
        fontFamily={visible ? 'mono' : undefined}
        fontSize={visible ? 'sm' : undefined}
      >
        {visible ? value : '••••••••'}
      </Text>
      <EyeButton visible={visible} onToggle={() => setVisible(!visible)} />
    </Flex>
  );
}
